'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _immutable = require('immutable');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  switch (action.type) {
    case 'GET_EVENTS_START':
      return state.setIn([action.feis_id], (0, _immutable.fromJS)({ loading: true }));

    case 'GET_EVENTS':
    case 'GET_EVENTS_WITH_STATUS':
      return state.setIn([action.feis_id], (0, _immutable.fromJS)({ all: action.payload }));

    case 'UPDATE_GROUP_FEE_ASSIGNED_TO_EVENT':
      return state.updateIn([action.feis_id, 'all'], function (list) {
        return list.map(function (event) {
          if (event.get('id') === action.event_id) {
            return (0, _immutable.fromJS)(_extends({}, event.toJS(), { groupFeeId: action.payload.id }));
          }
          return event;
        });
      });

    case 'DELETE_GROUP_FEE_ASSIGNED_TO_EVENT':
      return state.updateIn([action.feis_id, 'all'], function (list) {
        return list.map(function (event) {
          if (event.get('id') === action.event_id) {
            return (0, _immutable.fromJS)(_extends({}, event.toJS(), { groupFeeId: undefined }));
          }
          return event;
        });
      });

    case 'CREATE_EVENT':
      return state.setIn([action.feis_id, 'all'], state.getIn([action.feis_id, 'all']).push((0, _immutable.fromJS)(action.payload)));

    case 'UPDATE_EVENT':
      // app869 - use new payload here instead of merging existing reduced event in store with new payload. Merging retains the properties
      // that are deleted in new payload but are present in exsiting reduced payload and that causes old prop values
      // to appear on app pages like syllabus page.
      // In a perfect world, UPDATE_EVENT should always have an event in the response.
      // Just in case it doesn't, use the stored event in the payload.
      return state.setIn([action.feis_id, 'all'], (state.getIn([action.feis_id, 'all']) || (0, _immutable.List)()).map(function (e) {
        return e.get('id') === action.event_id ? (0, _immutable.fromJS)(action.payload || e.toJS()) : e;
      }));

    case 'SPLIT_EVENT':
      return state.setIn([action.feis_id, 'all'], state.getIn([action.feis_id, 'all']).filter(function (e) {
        return e.get('id') !== action.event_id;
      }).concat((0, _immutable.fromJS)(action.payload)));

    case 'MERGE_EVENT':
      return state.setIn([action.feis_id, 'all'], (state.getIn([action.feis_id, 'all']) || (0, _immutable.List)()).filter(function (e) {
        return e.get('id') !== action.ev_a_id && e.get('id') !== action.ev_b_id;
      }).push((0, _immutable.fromJS)(action.payload)));

    case 'DELETE_EVENT':
      return state.setIn([action.feis_id, 'all'], state.getIn([action.feis_id, 'all']).filter(function (e) {
        return e.get('id') !== action.event_id;
      }));

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/feiseanna/events/index.js
// module id = 695
// module chunks = 0